import React from 'react'
import { ButtonCta } from '../../../ui-lib/button'
import { useSignUpAction } from './hooks/useSignupAction'
import { SignUpProductRecButtonProps } from '../types'

export const SignUpProductRecButton: React.FC<SignUpProductRecButtonProps> = (props) => {
  const { placement, placementInternalName, toQueryParam, ...restProps } = props
  const onClick = useSignUpAction({ placement, placementInternalName, toQueryParam })

  return <ButtonCta onClick={onClick} {...restProps} />
}
